export default class LanguageTranslation {
    id: number;
    name: string;
    locale: string;
    language_id: number;
}
